export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerImport/GPimportOpen.png?9e7a48624fcf54fd12821a79c8b29c4f";